import { render, staticRenderFns } from "./ErrorsView.vue?vue&type=template&id=7ea472ca"
import script from "./ErrorsView.vue?vue&type=script&lang=js"
export * from "./ErrorsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports